import React from "react";
import SidebarLayout from "../../components/sidebarLayout";
import "./overView.css"; // CSS 파일 추가
import { Row, Col } from "react-bootstrap";
import menuData from "../../data/menuData"; // 메뉴 데이터 가져오기

export default function Overview() {
  const overviewMenu = menuData.find((menu) => menu.title === "포럼소개");

  const data = [
    { label: "설립연도", value: "2005년 창립, 2006년 문화체육관광부 허가" },
    {
      label: "설립목적",
      value:
        "관광 및 관련 산업분야 학문적 연구, 산관학 협력을 통한 선제적인 정책대안 제시로 한국관광 경쟁력 강화",
    },
    {
      label: "사업범위",
      value:
        "지자체 연구용역, 국내외 학술 세미나 개최, 저서 출판, 연구지 발간, 관광전문가 양성교육, 취업센터 운영등",
    },
    { label: "조직 구성", value: "분과위원회 및 지역위원회로 구성" },
  ];

  const ciImages = [
    "/images/ci/ci1.png",
    "/images/ci/ci2.png",
    "/images/ci/ci3.png",
    "/images/ci/ci4.png",
    "/images/ci/ci5.png",
    "/images/ci/ci6.jpeg",
    "/images/ci/ci7.jpeg",
  ];

  return (
    <div>
      <SidebarLayout menu={overviewMenu}>
        <div className="overview-section">
          {/* 데이터 섹션 */}
          {data.map((item, index) => (
            <Row key={index} className="overview-row">
              <Col md={3} className="overview-label">
                {item.label}
              </Col>
              <Col md={9} className="overview-value">
                {item.value}
              </Col>
            </Row>
          ))}
          {/* CI 섹션 */}
          <Row className="overview-row">
            <Col md={3} className="overview-label">
              CI
            </Col>
            <Col md={9} className="overview-value">
              <div className="ci-layout">
                {ciImages.map((src, index) => {
                  const downloadFilename = `ci${index + 1}.png`; // 다운로드 파일 이름
                  return (
                    <div
                      key={index}
                      className={
                        index < 3
                          ? "ci-wide"
                          : index < 5
                          ? "ci-half"
                          : "ci-pair"
                      }
                    >
                      <img
                        src={src}
                        alt={`CI 로고 ${index + 1}`}
                        className="ci-logo"
                      />
                      {/* <a
                        href={src}
                        download={downloadFilename}
                        className="download-icon"
                      >
                        <span role="img" aria-label="Download">
                          ⬇️
                        </span>
                      </a> */}
                    </div>
                  );
                })}
              </div>
            </Col>
          </Row>
        </div>
      </SidebarLayout>
    </div>
  );
}
